function cov_fx60l1n9v() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/Trash.tsx";
  var hash = "8a8450d4317bcca16d0c1d26e0a8d77b9561864c";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/Trash.tsx",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 45
        },
        end: {
          line: 4,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "8a8450d4317bcca16d0c1d26e0a8d77b9561864c"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_fx60l1n9v = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_fx60l1n9v();
var Icon = (cov_fx60l1n9v().s[0]++, {
  name: 'trash',
  svg: "<path xmlns=\"http://www.w3.org/2000/svg\" d=\"M7.3077 20.5C6.80898 20.5 6.38302 20.3234 6.02982 19.9701C5.67661 19.6169 5.5 19.191 5.5 18.6923V5.99999H5.25C5.03718 5.99999 4.85898 5.9282 4.7154 5.78462C4.5718 5.64103 4.5 5.46283 4.5 5.25002C4.5 5.0372 4.5718 4.859 4.7154 4.71542C4.85898 4.57182 5.03718 4.50002 5.25 4.50002H8.99997C8.99997 4.25515 9.08619 4.0465 9.25863 3.87407C9.43106 3.70163 9.63971 3.61542 9.88457 3.61542H14.1154C14.3602 3.61542 14.5689 3.70163 14.7413 3.87407C14.9138 4.0465 15 4.25515 15 4.50002H18.75C18.9628 4.50002 19.141 4.57182 19.2845 4.71542C19.4281 4.859 19.5 5.0372 19.5 5.25002C19.5 5.46283 19.4281 5.64103 19.2845 5.78462C19.141 5.9282 18.9628 5.99999 18.75 5.99999H18.5V18.6923C18.5 19.191 18.3233 19.6169 17.9701 19.9701C17.6169 20.3234 17.191 20.5 16.6922 20.5H7.3077ZM17 5.99999H6.99997V18.6923C6.99997 18.782 7.02883 18.8557 7.08652 18.9134C7.14422 18.9711 7.21795 19 7.3077 19H16.6922C16.782 19 16.8557 18.9711 16.9134 18.9134C16.9711 18.8557 17 18.782 17 18.6923V5.99999ZM9.40385 17H10.9038V7.99999H9.40385V17ZM13.0961 17H14.5961V7.99999H13.0961V17Z\" fill=\"currentColor\"/>"
});
export default Icon;